/** Shape of a single `{ value, label }` entry served by `GET /api/enums/audit-resource-types`. */
export type LabeledValuePayload = {
	readonly value: string;
	readonly label: string;
};

export type AuditResourceTypesFetchedPayload = LabeledValuePayload[];

export type AuditResourceTypesFetchedAction = {
	type: 'AUDIT_RESOURCE_TYPES_FETCHED';
	payload: AuditResourceTypesFetchedPayload;
};

export default (payload: AuditResourceTypesFetchedPayload): AuditResourceTypesFetchedAction => ({
	type: 'AUDIT_RESOURCE_TYPES_FETCHED',
	payload,
});
